import { render } from "./SpecificSignatureComponent.vue?vue&type=template&id=78b4123e&ts=true"
import script from "./SpecificSignatureComponent.vue?vue&type=script&lang=ts"
export * from "./SpecificSignatureComponent.vue?vue&type=script&lang=ts"

import "./SpecificSignatureComponent.vue?vue&type=style&index=0&id=78b4123e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__